import { Box, Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'src/icons/arrow-left';

interface Props {
  href: string;
}

const PageBackButton = ({ href }: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 4 }}>
      <Button
        component={Link}
        color="primary"
        startIcon={<ArrowLeft />}
        to={href}
        variant="text"
        sx={{
          color: 'text.primary',
        }}>
        {t('common:button.back')}
      </Button>
    </Box>
  );
};

export default PageBackButton;
